var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgControlSetAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Add",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58355",
    "data-name": "Group 58355",
    transform: "translate(-323.78 -64.78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56590",
    "data-name": "Group 56590",
    transform: "translate(324.23 65.23)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12635",
    "data-name": "Rectangle 12635",
    width: 2,
    height: 12,
    rx: 1,
    transform: "translate(4.55 -0.45)",
    fill: "#0072c6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12636",
    "data-name": "Rectangle 12636",
    width: 2,
    height: 12,
    rx: 1,
    transform: "translate(11.55 4.55) rotate(90)",
    fill: "#0072c6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlSetAdd);
export default __webpack_public_path__ + "static/media/controlSetAdd.b523fc0674650853c9304521ac6efbf0.svg";
export { ForwardRef as ReactComponent };